export default "__VITE_ASSET__82691919__"